/**
 * @module
 * @description Modern event handling utilities
 */

const on = (el, name, handler) => {
	el.addEventListener(name, handler);
};

const ready = (fn) => {
	if (document.readyState !== 'loading') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
};

const trigger = (opts = {}) => {
	const { data = {}, el = document, event = '', native = true } = opts;

	const eventObj = native
		? new Event(event, { bubbles: true, cancelable: false })
		: new CustomEvent(event, { detail: data, bubbles: true, cancelable: true });

	el.dispatchEvent(eventObj);
};

export { on, ready, trigger };
